@if (previewUrl()) {
    <iframe
        [src]="previewUrl()"
        #previewFrame></iframe>
}
